const events = {
	similarVehiclesClicked: 'Similar vehicles clicked',
	vdpRecommendationLoaded: 'VDP recommendation loaded',
	vdpRecommendationClicked: 'VDP recommendation clicked',
	vdpRecommendationSeeMore: 'VDP recommendation see more clicked',
	// Bid Modal
	bidModalClosedWithoutBidding: 'Bid Modal Closed Without Bidding',
	bidModalOpen: 'Buyer - Offer Modal Open',
	// Search page
	searchPageChangeVehicleCardFormat: 'Vehicle Card Format Changed',
	searchSuggestionApplied: 'Search suggestion applied',
	// market data
	marketDataModalOpen: 'Market Data Report Modal Opened',
	marketDataFallback: 'Market Data Report Fallback',
	partialSignupRequest: 'Partial Signup Request',
	auctionAccessError: 'AuctionACCESS Error',
	// audio boost
	sampleEngineAudioPlayed: 'Sample Engine Audio Played',
};

export default events;
